import React from 'react';

import { cssMap } from '@atlaskit/css';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { Inline } from '@atlaskit/primitives/compiled';

import { CardFooter as LegacyCardFooter } from './Legacy/CardFooter';

export type CardFooterProps = React.ComponentProps<typeof LegacyCardFooter>;

const styles = cssMap({
	footer: {
		gridArea: 'footer',
		position: 'relative',
		zIndex: 200,
		minWidth: 0,
	},
});

export const CardFooter = (props: CardFooterProps): React.JSX.Element => {
	if (!fg('rovo_agents_studio_browse_kit_uplift')) {
		return <LegacyCardFooter {...props} />;
	}

	const { children, testId } = props;

	return (
		<Inline
			xcss={styles.footer}
			space="space.100"
			alignInline="start"
			alignBlock="center"
			shouldWrap
			testId={testId}
		>
			{children}
		</Inline>
	);
};
